import React from 'react';
import { useReveal } from '../utils/useReveal';
import SectionLayout from './SectionLayout';

const Products: React.FC = () => {
  const { ref, isVisible } = useReveal();
  const products = [
    {
      title: 'Uidesk',
      description: 'Sistem manajemen data terintegrasi untuk mengorganisir, menganalisis, dan memanfaatkan data bisnis Anda secara optimal. Dapatkan insights yang actionable untuk pengambilan keputusan yang lebih baik.',
      images: [
        '/assets/uidesk1.jpg',
        '/assets/uidesk2.jpg',
        '/assets/uidesk3.jpg',
        '/assets/uidesk4.jpg',
        '/assets/uidesk5.jpg',
      ],
      link: '/datakelola',
    },
    {
      title: 'Uidesk Omnichannel',
      description: 'Platform CRM omnichannel yang memungkinkan bisnis mengelola semua interaksi pelanggan dari berbagai channel (WhatsApp, Email, Chat, Social Media) dalam satu dashboard terpadu. Tingkatkan responsivitas dan kepuasan pelanggan.',
      images: [
        '/assets/omnichannel1.jpg',
        '/assets/omnichannel2.jpg',
        '/assets/omnichannel3.jpg',
        '/assets/omnichannel4.jpg',
        '/assets/omnichannel5.jpg',
      ],
      link: '/omnichannel',
    },
    {
      title: 'Chatbot Automation',
      description: 'Solusi chatbot cerdas dengan teknologi AI untuk otomasi customer service 24/7. Tingkatkan efisiensi layanan pelanggan dengan respon instan, personalisasi, dan integrasi multi-channel yang seamless.',
      images: [
        '/assets/chatbot1.jpg',
        '/assets/chatbot2.jpg',
        '/assets/chatbot3.jpg',
        '/assets/chatbot4.jpg',
        '/assets/chatbot5.jpg',
      ],
      link: '/chatbot-automation',
    },
  ];

  return (
    <>
      <style>{`
        .portfolio-section {
          opacity: 0;
          transform: translateY(50px);
          transition: opacity 0.8s ease-out, transform 0.8s ease-out;
          /* Products sekarang menggunakan tema light (mengikuti global) */
          background: transparent;
          color: var(--text);
        }

        .portfolio-section.revealed {
          opacity: 1;
          transform: translateY(0);
        }

        .scroll-stack {
          position: relative;
        }

        .stack-card {
          position: sticky;
          top: 40px;
          padding: 80px 40px;
          margin: 0 -48px;
          border-radius: 24px;
          border: none;
          box-shadow: none;
        }

        .stack-card:nth-child(1) {
          background: #0a1628;
          color: #ffffff;
        }

        .stack-card:nth-child(2) {
          background: var(--stack-bg, #f0f5fa);
          color: #0a1628;
        }

        .stack-card:nth-child(3) {
          background: #0a1628;
          color: #ffffff;
        }

        .stack-card + .stack-card {
          margin-top: -20px;
        }

        .stack-card h3 {
          margin-bottom: 16px;
        }

        .stack-card .service-description {
          margin-bottom: 16px;
        }

        .stack-card .service-images {
          margin-top: 16px;
        }

        .service-title {
          font-size: clamp(28px, 4vw, 48px);
          font-weight: 700;
          letter-spacing: -0.02em;
          line-height: 1.2;
          margin-bottom: 24px;
        }

        .service-description {
          font-size: 17px;
          line-height: 1.8;
          color: var(--muted-2, rgba(255, 255, 255, 0.6));
          margin-bottom: 36px;
          max-width: 900px;
        }

        .stack-card:nth-child(1) .service-title,
        .stack-card:nth-child(3) .service-title {
          color: #ffffff;
        }

        .stack-card:nth-child(1) .service-description,
        .stack-card:nth-child(3) .service-description {
          color: rgba(255, 255, 255, 0.8);
        }

        .service-images {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 16px;
          margin-top: 40px;
        }

        .service-image {
          aspect-ratio: 1;
          background: var(--chip, rgba(255, 255, 255, 0.08));
          border-radius: 16px;
          background-size: cover;
        }

        .stack-card:nth-child(1) .service-image,
        .stack-card:nth-child(3) .service-image {
          background: rgba(255, 255, 255, 0.1);
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
        }

        /* Uidesk gambar 1, 2, 3, 5 - lebih zoom */
        .img-uidesk-1,
        .img-uidesk-2,
        .img-uidesk-3,
        .img-uidesk-5 {
          background-size: cover !important;
        }

        /* Omnichannel gambar 2, 3 - posisi lebih ke kiri */
        .img-uideskomnichannel-2,
        .img-uideskomnichannel-3 {
          background-position: left center !important;
        }

        /* Chatbot gambar 4 - lebih zoom */
        .img-chatbotautomation-4 {
          background-size: cover !important;
        }

        .cta-button {
          display: inline-flex;
          align-items: center;
          gap: 12px;
          background: var(--accent, #ffffff);
          color: var(--accent-contrast, #0f0f0f);
          padding: 18px 36px;
          border-radius: 50px;
          text-decoration: none;
          font-weight: 600;
          font-size: 16px;
          transition: all 0.3s;
          border: 2px solid var(--accent, #ffffff);
        }

        .cta-button:hover {
          background: transparent;
          color: var(--text, #ffffff);
          transform: scale(1.05);
        }

        .stack-card:nth-child(1) .cta-button,
        .stack-card:nth-child(3) .cta-button {
          background: #ffffff;
          color: #0a1628;
          border-color: #ffffff;
        }

        .stack-card:nth-child(1) .cta-button:hover,
        .stack-card:nth-child(3) .cta-button:hover {
          background: transparent;
          color: #ffffff;
          border-color: #ffffff;
        }

        @media (max-width: 768px) {
          .stack-card {
            margin: 0 -24px;
            padding: 60px 24px;
          }

          .service-images {
            grid-template-columns: repeat(3, 1fr);
          }
        }
      `}</style>
      <SectionLayout id="produk" maxWidth="2xl">
        <section 
          className={`portfolio-section ${isVisible ? 'revealed' : ''}`} 
          ref={ref as React.RefObject<HTMLElement>}
        >
          <div className="section-header">
            {/* <div className="section-label">Produk Kami</div> */}
            <h2 className="section-title">Produk Kami</h2>
            <p className="section-description">
              Solusi lengkap untuk mengelola customer experience, data, dan komunikasi bisnis Anda dengan teknologi terdepan.
            </p>
          </div>

        <div className="scroll-stack">
          {products.map((product, idx) => (
            <div key={idx} className="stack-card">
              <h3 className="service-title">{product.title}</h3>
              <p className="service-description">{product.description}</p>
              <div className="service-images">
                {product.images.map((img, imgIdx) => (
                  <div
                  key={imgIdx}
                  className={`service-image img-${product.title.toLowerCase().replace(/\s/g, '')}-${imgIdx + 1}`}
                  style={{ backgroundImage: `url('${img}')` }}
                />
                
                ))}
              </div>
            </div>
          ))}
        </div>

        </section>
      </SectionLayout>
    </>
  );
};

export default Products;

